import { Form as FormikForm, Formik } from 'formik';
import { useLocalization } from '../../../../context/Localization/localization';
import { nameof } from '../../../../helpers/nameof';
import { GMFormTextField } from '../../../../controls/TextField';
import { GMButton } from '../../../../controls/Button';
import { GMDialog } from '../../../../controls/Dialog';
import { GMFormTranslateErrors } from '../../../../controls/Form';
import { FormProvider } from '../../../../context/Form/form';

export const ExitToDeskTopDialog = (props: { onConfirm: (newPin: string) => void; open: boolean; onClose: () => void; }) => {
    const Localization = useLocalization();

    return (
        <Formik
            initialValues={{ pin: '' }}
            onSubmit={(values) => {
                props.onConfirm(values.pin);
            }}
        >
            {({ values, submitForm }) => (
                <GMFormTranslateErrors>
                    <GMDialog
                        ariaLabel={Localization.EnterPasscode}
                        open={props.open}
                        title={Localization.EnterPasscode}
                        actions={[
                            <GMButton
                                id={Localization.Close}
                                title={Localization.Close}
                                ariaLabel={Localization.Close}
                                onClick={props.onClose}
                            >
                                {Localization.Close}
                            </GMButton>,
                            <GMButton
                                id={Localization.ExitToDeskTop}
                                title={Localization.ExitToDeskTop}
                                ariaLabel={Localization.ExitToDeskTop}
                                onClick={submitForm}
                            >
                                {Localization.ExitToDeskTop}
                            </GMButton>,
                        ]}
                    >
                        <FormProvider>
                            <FormikForm>
                                <GMFormTextField
                                    name={nameof<typeof values>('pin')}
                                    id={nameof<typeof values>('pin')}
                                    title={'Pin'}
                                    label={''}
                                    ariaLabel={'Pin'}
                                />
                            </FormikForm>
                        </FormProvider>
                    </GMDialog>
                </GMFormTranslateErrors>
            )}
        </Formik>
    );
};
